(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["attribution-tracking"] && !Shopify.designMode) return;
  try {
    const attributionStorageKey = 'qomoor:attribution-journey:v2';
  const attributePrefix = '__qm_';
  let attributionSyncPromise;
  let syncedOnPage = false;

  const truncateAttribute = (value) => String(value || '').trim().slice(0, 240);

  const marketingAllowed = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;
    return !customerPrivacy || customerPrivacy.marketingAllowed();
  };

  const externalReferrerHost = () => {
    if (!document.referrer) return '';

    try {
      const referrer = new URL(document.referrer);
      return referrer.hostname === window.location.hostname ? '' : referrer.hostname;
    } catch {
      return '';
    }
  };

  const buildAttribution = () => {
    const parameters = new URLSearchParams(window.location.search);
    const referrerHost = externalReferrerHost();
    const clickIds = [
      ['gclid', 'google', 'cpc'],
      ['gbraid', 'google', 'cpc'],
      ['wbraid', 'google', 'cpc'],
      ['fbclid', 'meta', 'paid_social'],
      ['msclkid', 'bing', 'cpc'],
      ['ttclid', 'tiktok', 'paid_social'],
      ['epik', 'pinterest', 'paid_social'],
    ];
    const clickMatch = clickIds.find(([parameter]) => parameters.has(parameter));
    const source = parameters.get('utm_source') || clickMatch?.[1] || referrerHost || 'direct';
    const medium = parameters.get('utm_medium') || clickMatch?.[2] || (referrerHost ? 'referral' : '(none)');

    return {
      attribution: {
        source,
        medium,
        campaign: parameters.get('utm_campaign') || '',
        content: parameters.get('utm_content') || '',
        term: parameters.get('utm_term') || '',
        click_id: clickMatch ? parameters.get(clickMatch[0]) || '' : '',
        landing_path: window.location.pathname + window.location.search,
        referrer_host: referrerHost,
        captured_at: new Date().toISOString(),
      },
      hasAcquisitionSignal:
        parameters.has('utm_source') ||
        parameters.has('utm_medium') ||
        parameters.has('utm_campaign') ||
        Boolean(clickMatch) ||
        Boolean(referrerHost),
    };
  };

  const readStoredAttribution = () => {
    try {
      const stored = window.localStorage.getItem(attributionStorageKey);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  };

  const captureAttribution = () => {
    if (!marketingAllowed()) return null;

    const stored = readStoredAttribution();
    const candidate = buildAttribution();
    const journey = {
      first: stored?.first || candidate.attribution,
      last: candidate.hasAcquisitionSignal ? candidate.attribution : stored?.last || candidate.attribution,
    };

    try {
      window.localStorage.setItem(attributionStorageKey, JSON.stringify(journey));
    } catch {
      return journey;
    }

    return journey;
  };

  const privateCartAttributes = (journey) => {
    const attributes = {};

    for (const touchpoint of ['first', 'last']) {
      for (const [key, value] of Object.entries(journey[touchpoint] || {})) {
        if (value) attributes[attributePrefix + touchpoint + '_' + key] = truncateAttribute(value);
      }
    }

    return attributes;
  };

  const syncAttributionToCart = async () => {
    if (syncedOnPage) return;
    if (attributionSyncPromise) return attributionSyncPromise;

    const journey = captureAttribution();
    if (!journey) return;

    const root = window.Shopify?.routes?.root || '/';
    attributionSyncPromise = fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: privateCartAttributes(journey) }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Attribution sync failed');
        syncedOnPage = true;
      })
      .catch(() => undefined)
      .finally(() => {
        attributionSyncPromise = undefined;
      });

    return attributionSyncPromise;
  };

  captureAttribution();

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.data?.didError) return;
    syncAttributionToCart();
  });

  document.addEventListener('visitorConsentCollected', () => {
    captureAttribution();
    if (window.location.pathname.endsWith('/cart') || document.querySelector('.accelerated-checkout-block')) {
      syncAttributionToCart();
    }
  });

  const hasAcceleratedCheckout = Boolean(document.querySelector('.accelerated-checkout-block'));

  if (window.location.pathname.endsWith('/cart') || hasAcceleratedCheckout) syncAttributionToCart();

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('.accelerated-checkout-block, .additional-checkout-buttons')) return;
      syncAttributionToCart();
    },
    { capture: true, passive: true }
  );
  } catch(e) { console.error(e); }
})();

})();
